// Per-user defaults for the new-sale and new-purchase editors.
// Firestore owns the preference; localStorage is only a startup/offline cache
// and a migration path for the older per-page mode keys.
(function initCommerceViewPreferences(global) {
  const VALID_MODES = new Set(['steps', 'onepage']);
  const CONFIG = {
    sales: {
      preferenceKey: 'salesMode',
      cacheKey: 'plumme-sales-mode',
      legacyKeys: ['plumme-faktura-mode', 'plumme-salg-mode'],
    },
    purchase: {
      preferenceKey: 'purchaseMode',
      cacheKey: 'plumme-purchase-mode',
      legacyKeys: ['plumme-kjop-mode'],
    },
  };

  const normalizeMode = (value) => VALID_MODES.has(value) ? value : null;
  const configFor = (kind) => CONFIG[kind] || null;

  const readLocal = (kind) => {
    const config = configFor(kind);
    if (!config) return null;
    try {
      for (const key of [config.cacheKey, ...config.legacyKeys]) {
        const mode = normalizeMode(global.localStorage?.getItem(key));
        if (mode) return mode;
      }
    } catch (error) {}
    return null;
  };

  const profileMode = (kind) => {
    const config = configFor(kind);
    return config ? normalizeMode(global.PlummeBackend?.userProfile?.preferences?.[config.preferenceKey]) : null;
  };

  const preferredMode = (kind, ...candidates) => {
    for (const candidate of candidates) {
      const mode = normalizeMode(candidate);
      if (mode) return mode;
    }
    return profileMode(kind) || readLocal(kind);
  };

  const initialMode = (kind) => preferredMode(kind) || 'choose';
  const settingsMode = (kind, ...candidates) => preferredMode(kind, ...candidates) || 'steps';

  const cacheDefault = (kind, value) => {
    const config = configFor(kind);
    const mode = normalizeMode(value);
    if (!config || !mode) return null;
    try {
      global.localStorage?.setItem(config.cacheKey, mode);
      config.legacyKeys.forEach((key) => global.localStorage?.setItem(key, mode));
    } catch (error) {}
    return mode;
  };

  const saveDefault = async (kind, value) => {
    const config = configFor(kind);
    const mode = normalizeMode(value);
    if (!config || !mode) throw new Error(global.t ? global.t('pref.mode.unsupported') : 'pref.mode.unsupported');
    if (global.PlummeBackend?.updateUserPreferencePatch) {
      await global.PlummeBackend.updateUserPreferencePatch({ [config.preferenceKey]: mode });
    }
    cacheDefault(kind, mode);
    return mode;
  };

  global.PlummeCommerceViewPreferences = {
    normalizeMode,
    preferredMode,
    initialMode,
    settingsMode,
    cacheDefault,
    saveDefault,
  };
})(globalThis);
